module.exports = __webpack_public_path__ + "static/media/1.5f1f3577.png";